import { Button } from "components/ui/button/Button";
import "./welcome-v-one.scss";
import { ReactComponent as WelcomeGraphicDesktop } from "assets/images/WelcomeGraphicDesktop.svg";
import { ReactComponent as WelcomeGraphicMobile } from "assets/images/WelcomeGraphicMobile.svg";
import { useNavigate } from "react-router-dom";
import Footer from "components/footer/Footer";
import useDesktopChecker from "hooks/useDesktopChecker";
import { Consent } from "components/consent/Consent";
import * as Constant from "utilities/Constant";
import { useUpdateConsentStatusMutation } from "./welcomePathService";
import { getCurrentUserId, getNhDealApplicationId, setIsConsentCollected, setLogout } from "features/authSlice";
import { useDispatch, useSelector } from "react-redux";
import { LoadingOverlay } from "components/ui/loading-spinners";
import RedesignAnnouncementModal from "pages/announcements/re-design/re-design-modal";

export default function InterimWelcomePage({ isRedirectToDashboard }: { isRedirectToDashboard: boolean }) {
  const isDesktop = useDesktopChecker();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const nhDealApplicationId = useSelector(getNhDealApplicationId);
  const userId = useSelector(getCurrentUserId);
  const [UpdateConsentStatus, { isSuccess, isError, isLoading, error }] = useUpdateConsentStatusMutation();
  const handleOnSubmit = async () => {
    await UpdateConsentStatus({
      userId,
      nhDealApplicationId,
    });
  };

  if (isSuccess) {
    dispatch(setIsConsentCollected(true));
    if (isRedirectToDashboard) {
      navigate("/dashboard", { replace: true });
    } else {
      navigate("/application", { replace: true });
    }
  } else if (isError || error) {
    dispatch(setLogout());
    navigate("/", { replace: true, state: { path: location.pathname } });
  }

  if (isLoading) return <LoadingOverlay />;

  return (
    <>
      <RedesignAnnouncementModal />
      <div className="welcome-page">
        <div className="welcome-container">
          <div className="welcome-page_title">{Constant.welcomeHeader}</div>
          <div className="welcome-page_description">
            <p className="welcome-page_description__one">{Constant.welcomeSubtext}</p>
          </div>
          <div className="welcome-page_graphic">{isDesktop ? <WelcomeGraphicDesktop /> : <WelcomeGraphicMobile />}</div>
          <Button className="welcome-page_button" title="Continue" onClick={() => void handleOnSubmit()} />
          <Consent text={Constant.WELCOME_PAGE_CONSENT} />
        </div>
      </div>
      <Footer />
    </>
  );
}
